// extracted by mini-css-extract-plugin
module.exports = {"clickableContainer":"storage-incentives_clickableContainer_qG8"};